import { PermissionIdentifier } from '../src/access';

const strPath = {
  1: 'project',
  3: 'auth',
  4: 'price',
  5: 'rcsCost',
  6: 'custPrice',
  7: 'custPriceMolm',
};
const path = (str: string) => `/myTodo/${str}/approved`;
const application = (str: string) => `/myApplication/${str}/approved`;
const home = (str: string) => `/home/index/${str}/approved`;

const resList = (path: Function, name: string) => {
  const approvedList: any = [
    // 项目审批
    // {
    //   name,
    //   path: path(strPath['1']),
    //   component: './ProjectTracking/projectManagement/projectDetail/components/ViewTabsContent',
    //   hideInMenu: true,
    // },
  ];
  return approvedList;
};

const routes = [
  {
    name: '登录',
    path: '/login',
    component: './Login',
  },
  {
    name: '个人中心',
    path: '/personalCenter',
    component: './personalCenter',
  },
  {
    path: '/',
    redirect: '/home',
    hideInMenu: true,
    layout: false,
  },
  {
    name: '首页',
    path: '/home',
    icon: '/home.svg',
    component: '@/layouts/BaseLayout.tsx',
    routes: [
      {
        path: '/home',
        redirect: '/home/index',
        hideInMenu: true,
      },
      {
        name: '首页',
        path: '/home/index',
        icon: '/home.svg',
        component: './Home',
        isBack: true,
        hideInMenu: true,
      },
    ],
  },
  {
    name: '系统管理',
    path: '/systemManagement',
    component: '@/layouts/BaseLayout.tsx',
    access: PermissionIdentifier.SystemManagement,
    routes: [
      {
        name: '用户管理',
        path: '/systemManagement/userManagement',
        component: './systemManagement/userManagement',
        access: PermissionIdentifier.UserManagement,
      },
      {
        name: '权限管理',
        path: '/systemManagement/permissionManagement',
        component: './systemManagement/permissionManagement',
        access: PermissionIdentifier.PermissionManagement,
      },
      {
        name: '菜单管理',
        path: '/systemManagement/menuManagement',
        component: './systemManagement/menuManagement',
        access: PermissionIdentifier.MenuManagement,
      },
      {
        name: '字典管理',
        path: '/systemManagement/dictionaryManagement',
        component: './systemManagement/dictionaryManagement',
        access: PermissionIdentifier.DictionaryManagement,
      },
      {
        name: '日志管理',
        path: '/systemManagement/logManagement',
        component: './systemManagement/logManagement',
        access: PermissionIdentifier.LogManagement,
      },
      {
        name: 'AI测试',
        path: '/systemManagement/ai-test',
        component: './aiTest',
      },
    ],
  },
  {
    name: '系统数据管理',
    path: '/systemDataManagement',
    hideInMenu: false,
    component: '@/layouts/BaseLayout.tsx',
    access: PermissionIdentifier.SystemDataManagement,
    routes: [
      {
        name: '物料类型维护',
        path: '/systemDataManagement/materialTypeMaintenance',
        component: './systemDataManagement/materialTypeMaintenance',
        access: PermissionIdentifier.MaterialType,
      },
      {
        name: 'VC属性维护',
        path: '/systemDataManagement/vcAttributeMaintenance',
        component: './systemDataManagement/vcAttributeMaintenance',
        access: PermissionIdentifier.VCAttribute,
      },
      {
        name: 'Module List维护',
        path: '/systemDataManagement/moduleListMaintenance',
        access: PermissionIdentifier.ModuleList,
        routes: [
          {
            name: 'Module List维护',
            path: '/systemDataManagement/moduleListMaintenance',
            component: './systemDataManagement/moduleListMaintenance',
            hideInMenu: true,
          },
          {
            name: '历史版本',
            path: '/systemDataManagement/moduleListMaintenance/history',
            component:
              './systemDataManagement/moduleListMaintenance/moduleListHistory',
            access: PermissionIdentifier.ModuleList,
            hideInMenu: true,
          },
        ],
      },
      {
        name: '提醒逻辑维护',
        path: '/systemDataManagement/notificationLogicMaintenance',
        component: './systemDataManagement/notificationLogicMaintenance',
        access: PermissionIdentifier.Reminder,
      },
      {
        name: '校对逻辑维护',
        path: '/systemDataManagement/validationRuleMaintenance',
        component: './systemDataManagement/validationRuleMaintenance',
        access: PermissionIdentifier.Proofreading,
      },
      {
        name: '审批流程管理',
        path: '/systemDataManagement/approvalProcessManagement',
        component: './systemDataManagement/approvalProcessManagement',
        access: PermissionIdentifier.ApprovalProcess,
      },
      {
        name: '物料主数据查询',
        path: '/systemDataManagement/materialMasterDataQuery',
        component: './systemManagement/materialMasterDataQuery',
        access: PermissionIdentifier.MaterialMasterQuery,
      },
      {
        name: '产品代码查询',
        path: '/systemDataManagement/productCodeQuery',
        component: './systemManagement/productCodeQuery',
        access: PermissionIdentifier.ProductCodeQuery,
      },
      {
        name: 'VC Level1查询',
        path: '/systemDataManagement/vcLevel1Query',
        component: './systemManagement/vcLevel1Query',
        access: PermissionIdentifier.VCLevel1Query,
      },
      {
        name: '首页管理',
        path: '/systemDataManagement/homePageManagement',
        component: './systemDataManagement/homePageManagement',
        access: PermissionIdentifier.HomePageManagement,
      },
    ],
  },
  {
    name: '流程审批管理',
    path: '/processApproval',
    component: '@/layouts/BaseLayout.tsx',
    access: PermissionIdentifier.WorkflowApproval,
    routes: [
      {
        name: '我的申请',
        path: '/processApproval/all',
        access: PermissionIdentifier.MyApplication,
        routes: [
          {
            name: '我的申请',
            path: '/processApproval/all',
            component: './processApproval/all',
            hideInMenu: true,
          },
          {
            name: 'Module List流程',
            path: '/processApproval/all/moduleListProcess',
            component: './processApproval/all/moduleListProcess',
            hideInMenu: true,
          },
        ],
      },
      {
        name: '待审批',
        path: '/processApproval/pending',
        // component: './processApproval/pending',
        access: PermissionIdentifier.PendingApproval,
        routes: [
          {
            name: '待审批',
            path: '/processApproval/pending',
            component: './processApproval/pending',
            hideInMenu: true,
          },
          {
            name: 'Module List流程',
            path: '/processApproval/pending/moduleListProcess',
            component: './processApproval/pending/moduleListProcess',
            hideInMenu: true,
          },
        ],
      },
    ],
  },
  {
    name: '订单信息查询',
    path: '/orderQuery',
    component: '@/layouts/BaseLayout.tsx',
    access: PermissionIdentifier.OrderQuery,
    routes: [
      {
        name: '订单信息查询',
        path: '/orderQuery/orderInfo',
        component: './orderQuery/orderInfo',
        access: PermissionIdentifier.OrderQuery,
      },
      {
        name: '模拟BOM管理',
        path: '/orderQuery/simulateBom',
        component: './orderQuery/simulateBom',
        access: PermissionIdentifier.SimulatedBOM,
      },
      {
        name: '订单详情',
        path: '/orderQuery/orderInfo/orderMore',
        component: './orderQuery/orderMore',
        hideInMenu: true,
      },
    ],
  },

  {
    name: '冲突处理',
    path: '/systemDataManagement/moduleListMaintenance/conflict',
    component: './systemDataManagement/moduleListMaintenance/conflict',
    hideInMenu: true,
    layout: false,
  },
  { path: '/404', name: '404', component: './404', hideInMenu: true },
  { path: '/403', name: '403', component: './403', hideInMenu: true },
];

const treeToArray = (tree: any) => {
  let res: any = [];
  for (const item of tree) {
    const { routes, ...i } = item;
    if (routes && routes.length) {
      res = res.concat(treeToArray(routes));
    }
    res.push(i);
  }
  return res;
};

export { application, home, path, strPath };
export const flattenRoutes = treeToArray(routes);
export default routes;
